import { useEffect } from 'react';

const useFormFieldFocus = elementId => {
    useEffect(() => {
        const timer = setTimeout(() => {
            const element = document.getElementById(elementId);
            if (element) {
                element.focus();
            }
        }, 300);

        return () => clearTimeout(timer);

    }, []);
};

export default useFormFieldFocus;